import type { TypedDocumentNode } from '@apollo/client';

import { gql } from '@apollo/client';

import { MESSAGE_FIELDS } from '#/graphql/fragments/message-fields';
import type {
  CreateMessageMutation,
  CreateMessageMutationVariables,
} from '#/graphql/generated';

export const CREATE_MESSAGE: TypedDocumentNode<
  CreateMessageMutation,
  CreateMessageMutationVariables
> = gql`
  ${MESSAGE_FIELDS}
  mutation CreateMessage($input: CreateMessageInput!) {
    createMessage(input: $input) {
      ...MessageFields
      childMessages {
        ...MessageFields
      }
    }
  }
`;
